import React, { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import { Icon, SecondaryButton } from "@prestosports/commons-ui";
import Typography from "@material-ui/core/Typography";
import Add32 from "@carbon/icons-react/lib/add/32";
import Box from "@material-ui/core/Box";
import { Videocam } from "@material-ui/icons";
import personnelListStyles from "../styles/sports/PersonnelList.styles";
import commonStyles from "../styles/Common.styles";
import StreamListItem from "./StreamListItem";

const StreamList = ({ streams = [], onDelete, onSave, eventId }) => {
	const classes = personnelListStyles();
	const commonClasses = commonStyles();
	const [pendingStream, setPendingStream] = useState(null);

	const streamList = [...streams];
	if (pendingStream) {
		streamList.push(pendingStream);
	}

	const clearPendingStream = () => {
		setPendingStream(null);
	};

	const handleDelete = (stream) => {
		if (stream.id) {
			onDelete(stream.id);
		} else {
			clearPendingStream();
		}
	};

	const handleSave = (stream) => {
		onSave(stream);
		if (!stream.id) {
			clearPendingStream();
		}
	};

	return (
		<>
			<Grid item xs={12} sm={6}>
				<Typography variant="h5">Stream</Typography>
			</Grid>
			<Grid item xs={12} sm={6} style={{ textAlign: "right" }}>
				<SecondaryButton
					id="button-add-stream"
					disabled={!!pendingStream || streams.length >= 2}
					startIcon={
						<Icon>
							<Add32 />
						</Icon>
					}
					onClick={() => setPendingStream({})}
					label="Add Stream"
				/>
			</Grid>
			<Grid item xs={12}>
				{streamList.length ? (
					<List disablePadding>
						{streamList.map((s, index) => (
							<ListItem key={s.id} disableGutters className={classes.listItem}>
								<StreamListItem
									eventId={eventId}
									stream={s}
									index={index}
									handleDelete={handleDelete}
									handleSave={handleSave}
								/>
							</ListItem>
						))}
					</List>
				) : (
					<Box
						alignItems="center"
						display="flex"
						flexDirection="column"
						justifyContent="center"
						className={commonClasses.container}
					>
						<Videocam className={commonClasses.contentCenteredIcon} />
					</Box>
				)}
			</Grid>
		</>
	);
};

export default StreamList;
